<span class="cropped-text" #croppedText [matTooltip]="shouldShowTooltip() ? text : null">
  <span class="cropped-text__inner" #viewedText>{{ text }}</span>
</span>
